import { render, staticRenderFns } from "./desmosModal.vue?vue&type=template&id=14ad4987&lang=pug&"
import script from "./desmosModal.vue?vue&type=script&lang=js&"
export * from "./desmosModal.vue?vue&type=script&lang=js&"
import style0 from "./desmosModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports